<template>
  <form @submit.prevent="submit">
    <h6>Name:</h6>

    <div class="row mb-4">
      <div class="col-6">
        <div class="input firstname">
          <input type="text" class="firstname" name="firstname" :id="`driver-firstname-${uid}`" v-model.lazy="payload.firstname" required>
          <label :for="`driver-firstname-${uid}`">Firstname<span class="req">*</span></label>
        </div>
      </div>
      <div class="col-6">
        <div class="input surname">
          <input type="text" class="surname" name="surname" :id="`driver-surname-${uid}`" v-model.lazy="payload.surname" required>
          <label :for="`driver-surname-${uid}`">Surname<span class="req">*</span></label>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <div class="input email">
          <input type="email" class="email" name="email" :id="`driver-email-${uid}`" v-model.lazy="payload.email" required>
          <label :for="`driver-email-${uid}`">Email<span class="req">*</span></label>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <div class="lightswitch lightswitch-left">
          <input type="checkbox" name="mainDriver" :id="`driver-main-driver-${uid}`" class="mainDriver" v-model="payload.mainDriver">
          <label :for="`driver-main-driver-${uid}`">Set as Main Driver</label>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <div class="input">
          <input type="date" v-model="dateOfBirth" class="form-control" :id="`driver-dob-${uid}`" required>
          <label :for="`driver-dob-${uid}`">Date of Birth<span class="req">*</span></label>
        </div>
      </div>
    </div>

    <div v-if="payload.driverID" class="row mb-4">
      <div class="col-12">
        <div class="input address">
          <input type="text" class="address" name="address" :id="`driver-address-${uid}`" v-model.lazy="payload.address" required>
          <label :for="`driver-address-${uid}`">Address<span class="req">*</span></label>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <div class="input postcode">
          <input type="text" class="postcode" name="postcode" :id="`driver-postcode-${uid}`" v-model.lazy="payload.postcode" required>
          <label :for="`driver-postcode-${uid}`">Postcode<span class="req">*</span></label>
        </div>
      </div>
    </div>

    <div v-if="payload.driverID" class="row mb-4">
      <div class="col-12">
        <div class="input mobile-phone">
          <input type="text" class="mobile-phone" name="mobile_phone" :id="`driver-mobile-phone-${uid}`" v-model.lazy="payload.mobilePhone" required>
          <label :for="`driver-mobile-phone-${uid}`">Mobile Phone<span class="req">*</span></label>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <div class="input driving-license">
          <input type="text" class="driving-license" name="driving_license" :id="`driver-driving-license-${uid}`" v-model.lazy="payload.drivingLicense" required>
          <label :for="`driver-driving-license-${uid}`">Driving License #<span class="req">*</span></label>
        </div>
      </div>
    </div>

    <div v-if="payload.driverID" class="row mb-4">
      <div class="col-12">
        <div class="custom-multiselect">
          <label for="driver-profile-tax-band">Tax Band (%)<span class="req">*</span></label>
          <multiselect
            id="driver-profile-tax-band"
            v-model="payload.taxBand"
            :options="taxBandsOptions"
            group-values="options"
            group-label="group"
            :group-select="false"
            :show-labels="false"
          >
          </multiselect>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <label class="d-block mb-2">Is the driver a permanent UK resident?<span class="req">*</span></label>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`points-${uid}`" :id="`driver-permanent-uk-resident-yes-${uid}`" value="Yes" v-model="payload.insuranceQuestions['Is the driver a permanent UK resident']"
          required>
        <label class="form-check-label" :for="`driver-permanent-uk-resident-yes-${uid}`">Yes</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`points-${uid}`" :id="`driver-permanent-uk-resident-no-${uid}`" value="No" v-model="payload.insuranceQuestions['Is the driver a permanent UK resident']"
          required>
        <label class="form-check-label" :for="`driver-permanent-uk-resident-no-${uid}`">No</label>
      </div>
    </div>

    <div class="mb-4">
      <label class="d-block mb-2">Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document?<span class="req">*</span></label>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`full-valid-license-${uid}`" :id="`driver-full-valid-license-yes-${uid}`" value="Yes"
          v-model="payload.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document']" required>
        <label class="form-check-label" :for="`driver-full-valid-license-yes-${uid}`">Yes</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`full-valid-license-${uid}`" :id="`driver-full-valid-license-no-${uid}`" value="No"
          v-model="payload.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document']" required>
        <label class="form-check-label" :for="`driver-full-valid-license-no-${uid}`">No</label>
      </div>
    </div>

    <div class="mb-4">
      <label class="d-block mb-2">Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS?<span class="req">*</span></label>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`convictions-${uid}`" :id="`driver-convictions-yes-${uid}`" value="Yes"
          v-model="payload.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS']" required>
        <label class="form-check-label" :for="`driver-convictions-yes-${uid}`">Yes</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`convictions-${uid}`" :id="`driver-convictions-no-${uid}`" value="No"
          v-model="payload.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS']" required>
        <label class="form-check-label" :for="`driver-convictions-no-${uid}`">No</label>
      </div>
    </div>

    <div class="mb-4">
      <label class="d-block mb-2">Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT?<span class="req">*</span></label>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`convictions-other-${uid}`" :id="`driver-convictions-other-yes-${uid}`" value="Yes"
          v-model="payload.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT']" required>
        <label class="form-check-label" :for="`driver-convictions-other-yes-${uid}`">Yes</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`convictions-other-${uid}`" :id="`driver-convictions-other-no-${uid}`" value="No"
          v-model="payload.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT']" required>
        <label class="form-check-label" :for="`driver-convictions-other-no-${uid}`">No</label>
      </div>
    </div>

    <div class="mb-4">
      <label class="d-block mb-2">Has the driver received any conviction which has resulted in a driving ban in the last 5 years?<span class="req">*</span></label>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`ban-${uid}`" :id="`driver-ban-yes-${uid}`" value="Yes"
          v-model="payload.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years']" required>
        <label class="form-check-label" :for="`driver-ban-yes-${uid}`">Yes</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`ban-${uid}`" :id="`driver-ban-no-${uid}`" value="No"
          v-model="payload.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years']" required>
        <label class="form-check-label" :for="`driver-ban-no-${uid}`">No</label>
      </div>
    </div>

    <div class="mb-4">
      <label class="d-block mb-2">Has the driver had more than 1 FAULT claim in the last 3 years?<span class="req">*</span></label>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`faults-${uid}`" :id="`driver-faults-yes-${uid}`" value="Yes" v-model="payload.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years']" required>
        <label class="form-check-label" :for="`driver-faults-yes-${uid}`">Yes</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" :name="`faults-${uid}`" :id="`driver-faults-no-${uid}`" value="No" v-model="payload.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years']" required>
        <label class="form-check-label" :for="`driver-faults-no-${uid}`">No</label>
      </div>
    </div>

    <div class="text-right">
      <button v-if="payload.additionalDriverID" type="button" class="button button--remove me-2" @click="confirmDelete">Delete Driver</button>
      <input type="submit" value="Save" class="button button--steelBlue">
    </div>

  </form>
</template>

<script setup>
import {reactive, computed, watch, getCurrentInstance} from 'vue';
import Multiselect from "vue-multiselect";

const uid = getCurrentInstance().uid;
const taxBandsOptions = [
  {
    group: 'Tax Rates',
    options: [20, 40, 45]
  },
  /*{
    group: 'Scottish Tax Rates',
    options: [19, 21, 42, 48]
  }*/
];

const months = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const props = defineProps({
  driver: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['save', 'delete', 'percent-updated']);

const payload = reactive(JSON.parse(JSON.stringify(props.driver)));


// Percentage calculation based on live form state (payload)
// Text inputs use v-model.lazy so percent updates on blur
// Radio buttons, checkboxes, and multiselect update on change
const INSURANCE_QUESTION_COUNT = 6;
const isFilled = v => v !== null && v !== undefined && v !== '' && v !== false;

const percent = computed(() => {
  const d = payload;
  const basic = [d.firstname, d.surname, d.email, d.dob, d.postcode, d.drivingLicense];
  const employee = d.driverID ? [d.address, d.mobilePhone, d.taxBand] : [];
  const allFields = [...basic, ...employee];

  let filled = allFields.filter(isFilled).length;
  filled += Object.values(d.insuranceQuestions || {}).filter(isFilled).length;

  const total = allFields.length + INSURANCE_QUESTION_COUNT;
  return Math.round((filled / total) * 100);
});

watch(percent, val => emit('percent-updated', val), {immediate: true});

const dateOfBirth = computed({
  get: () => payload.dob ? payload.dob.substring(0, 10) : '',
  set: (v) => payload.dob = v ? v + ' 00:00:00' : '',
});

function confirmDelete() {
  if (confirm('Are you sure you want to delete this driver?')) {
    emit('delete', payload);
  }
}

function submit() {
  const dobDate = payload.dob ? new Date(payload.dob) : null;
  const submitPayload = {
    ...payload,
    dob: dobDate ? {
      month: months[dobDate.getMonth()],
      day: dobDate.getDate(),
      year: dobDate.getFullYear(),
    } : {month: null, day: null, year: null},
  };

  emit('save', submitPayload);
}
</script>

<style scoped>

</style>
